import AlertCard from './AlertCard';
import LinkedOperationsAlert from './LinkedOperationsAlert';
import CustomerCountryList from './CustomerCountryList';
import NonFatfCountriesList from './NonFatfCountriesList';
import SelectedCountriesSummary from './SelectedCountriesSummary';
import SelectedAlertsList from './SelectedAlertsList';

interface AlertGridProps {
  alertOptions: string[];
  selectedAlerts: string[];
  linkedOpsAmount: number;
  linkedOpsHours: number;
  linkedOpsBase: string;
  customerCountryListBase: string;
  selectedCountries: string[];
  onAlertChange: (alert: string, isSelected: boolean) => void;
  onLinkedOpsAmountChange: (amount: number) => void;
  onLinkedOpsHoursChange: (hours: number) => void;
  onCountriesChange: (countries: string[]) => void;
}

function AlertGrid({
  alertOptions,
  selectedAlerts,
  linkedOpsAmount,
  linkedOpsHours,
  linkedOpsBase,
  customerCountryListBase,
  selectedCountries,
  onAlertChange,
  onLinkedOpsAmountChange,
  onLinkedOpsHoursChange,
  onCountriesChange
}: AlertGridProps): JSX.Element {
  return (
    <div className="App-alerts-container">
      <div className="App-alerts-grid">
        {alertOptions.map((alert) => {
          const isLinkedOps = alert === linkedOpsBase;
          const isCustomerCountryList = alert === customerCountryListBase;
          const isNonFatf = alert === 'Non FATF countries';
          const isSelected = selectedAlerts.includes(alert) || 
            (alert === linkedOpsBase && selectedAlerts.some(a => 
              a.startsWith('Transfers above') && a.includes('linked operations')
            )) ||
            (alert === customerCountryListBase && selectedAlerts.some(a => 
              a.startsWith('Customer country list')
            ));

          return (
            <AlertCard
              key={alert}
              alert={alert}
              isSelected={isSelected}
              onToggle={onAlertChange}
            >
              {isLinkedOps ? (
                <LinkedOperationsAlert
                  amount={linkedOpsAmount}
                  hours={linkedOpsHours}
                  onAmountChange={onLinkedOpsAmountChange}
                  onHoursChange={onLinkedOpsHoursChange}
                />
              ) : isCustomerCountryList ? (
                <CustomerCountryList
                  selectedCountries={selectedCountries}
                  onCountriesChange={onCountriesChange}
                />
              ) : isNonFatf ? (
                <NonFatfCountriesList />
              ) : (
                <span className="App-alert-text">{alert}</span>
              )}
            </AlertCard>
          );
        })}
        <SelectedCountriesSummary
          selectedCountries={selectedCountries}
          isNonFatfSelected={selectedAlerts.includes('Non FATF countries')}
        />
      </div>
      <SelectedAlertsList selectedAlerts={selectedAlerts} />
    </div>
  );
}

export default AlertGrid;

